import React, { useState, useEffect, useRef, useContext } from 'react';
import { getSFTime } from 'services/formatDateToTimezone/formatDateToTimezone';
import PropTypes from 'prop-types';
import MobileContext from 'context/MobileContext';
import { ClassesHeader } from './ClassesHeader';
import { ClassesContent } from './ClassesContent';
import { calculateFourWeeksDates } from './service';

export const ClassesNew = ({
  loadClubs,
  clubs,
  classes,
  filteredClasses,
  isRequesting,
  loadClassesSchedule,
  searchValue,
  lastSucceeded,
  loadClubsIsRequesting,
  preselectedClub,
  changeSelectedClub,
  isExistFilters,
}) => {
  const isMobile = useContext(MobileContext);
  const datesRange = calculateFourWeeksDates();
  const [targetDate, setTargetDate] = useState(datesRange[0]);
  const [selectedClub, setSelectedClub] = useState(preselectedClub || 'all');

  const bodyRef = useRef(null);

  useEffect(() => {
    loadClubs();
  }, [loadClubs]);

  useEffect(() => {
    loadClassesSchedule({
      startDate: targetDate.date || getSFTime(),
      clubId: selectedClub,
    });
    // eslint-disable-next-line
  }, [selectedClub, targetDate]);

  return (
    // isRequesting && loadClubsIsRequesting && !clubs.length ? (
    //   <Spinner />
    // ) : (
    <div ref={bodyRef}>
      <ClassesHeader
        selectedClub={selectedClub}
        setSelectedClub={setSelectedClub}
        clubs={clubs}
        isMobile={isMobile}
        lastSucceeded={lastSucceeded}
        changeSelectedClub={changeSelectedClub}
      />
      <ClassesContent
        datesRange={datesRange}
        targetDate={targetDate}
        setTargetDate={setTargetDate}
        isMobile={isMobile}
        isRequesting={isRequesting}
        loadClubsIsRequesting={loadClubsIsRequesting}
        clubs={clubs}
        classes={
          isExistFilters ? filteredClasses : searchValue ? filteredClasses : classes
        }
      />
    </div>
  );
};

ClassesNew.propTypes = {
  classes: PropTypes.array,
  filteredClasses: PropTypes.array,
  clubs: PropTypes.array,
  loadClubs: PropTypes.func.isRequired,
  preselectedClub: PropTypes.string.isRequired,
  loadClassesSchedule: PropTypes.func.isRequired,
  addClassToFavorite: PropTypes.func.isRequired,
  removeClassFromFavorite: PropTypes.func.isRequired,
  isRequesting: PropTypes.bool.isRequired,
  searchValue: PropTypes.string,
  searchClasses: PropTypes.func.isRequired,
  lastSucceeded: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setError: PropTypes.func.isRequired,
  favoriteClub: PropTypes.string,
  loadClubsIsRequesting: PropTypes.bool.isRequired,
  isClassCallPopUpOpened: PropTypes.bool.isRequired,
  handleOpenClassCallPopUp: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  changeSelectedClub: PropTypes.func.isRequired,
  filters: PropTypes.object.isRequired,
  filterClasses: PropTypes.func.isRequired,
  isExistFilters: PropTypes.bool.isRequired,
};

ClassesNew.defaultProps = {
  classes: [],
  filteredClasses: [],
  clubs: [],
  favoriteClub: '',
  searchValue: '',
  lastSucceeded: '',
};
